// extracted by mini-css-extract-plugin
module.exports = {"lead-chevron-container":"lead-count-avatar__lead-chevron-container___1TKei","count-container":"lead-count-avatar__count-container___32Qar"};